export default __webpack_public_path__ + "static/media/EricHoerdemann-min.f84c5f23.jpeg";